<div class="modal-wrapper">
    <div class="common-modal">
        <span v-if="showCrossBtn" class="modal-close" @click="crossBtnClicked">
            <CloseIcon/>
        </span>
        <div class="modal-content">
            <div class="modal-header" v-if="showHeader">
                {{ modalHeading }}
            </div>
            <div class="modal-body" v-if="showContent" v-html="modalContent">
            </div>
            <div class="modal-footer">
                <button :class="customBtn1Class ? 'customBtn1Class' : ''" class="modal-button1" @click="btn1Clicked" v-if="showButton1">
                    {{ modalButton1 }}
                </button>
                <button class="modal-button2" @click="btn2Clicked" v-if="showButton2">
                    {{ modalButton2 }}
                </button>
            </div>
        </div>
    </div>
</div>